/*
 * Copyright 2024, Corning Optical Communications
 * All Rights Reserved.
 */

import { createSlice } from "@reduxjs/toolkit";
import {
  setSelectedEquipmentTypeAction,
  setSelectedStatusAction,
  setSelectedBandAction,
  setSearchTextAction,
  resetDasInventoryFiltersAction,
} from "./actions";
import { initialDasInventoryFilterState } from "./types";

const dasInventoryFilterSlice = createSlice({
  name: "dasInventoryFilter",
  initialState: initialDasInventoryFilterState,
  reducers: {
    setSelectedEquipmentType: setSelectedEquipmentTypeAction,
    setSelectedStatus: setSelectedStatusAction,
    setSelectedBand: setSelectedBandAction,
    setSearchText: setSearchTextAction,
    resetDasInventoryFilters: resetDasInventoryFiltersAction,
  },
});

export const DasInventoryFilterReducer = dasInventoryFilterSlice.reducer;
export const {
  setSelectedEquipmentType,
  setSelectedStatus,
  setSelectedBand,
  setSearchText,
  resetDasInventoryFilters,
} = dasInventoryFilterSlice.actions;
